import tw from 'twin.macro'
import styled from 'styled-components'

export const EventStatsWrapper = styled.div`
  ${tw`flex flex-col gap-8 mt-11 sm:mt-[81px] w-full max-w-full lg:flex-row`}
`
